/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 *
 * @file FilterListComponent.jsx
 * @author Srinivasan Bakthavatchalam
 * @since 1.0.1
 */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import { Icon } from '@greenville/mui-theme';
import { injectIntl, intlShape } from 'react-intl';

import { CONTENT_TYPE_KEYS } from '../../common/constants';
import messages from '../../../translations/defaultMessages';

const styles = (theme) => ({
  menuItem: {
    alignItems: 'center',
    background: theme.color.background,
    color: theme.color.textPrimary,
    border: 'none',
    borderBottom: `1px solid ${theme.color.divider}`,
    display: 'flex',
    fontFamily: 'Hind',
    fontStyle: 'normal',
    fontWeight: 16,
    justifyContent: 'space-between',
    padding: '10px 20px',
    '&:hover': {
      background: theme.color.background
    }
  },
  menuContentType: {
    display: 'flex'
  },
  menuContentTypeIcon: {
    paddingRight: 10
  },
  selectedSpan: {
    color: theme.color.activePrimary
  }
});

const FilterListComponent = ({
  classes,
  contentTypes,
  onMenuClick,
  selectedContentType,
  intl
}) => {
  const { formatMessage } = intl;

  return (
    <Fragment>
      <MenuItem
        className={classes.menuItem}
        onClick={event => onMenuClick(event, contentTypes[CONTENT_TYPE_KEYS.TYPE])}
      >
        <div className={classes.menuContentType}>
          {contentTypes[CONTENT_TYPE_KEYS.ICON] &&
          <span className={classes.menuContentTypeIcon}>
            <Icon
              name={contentTypes[CONTENT_TYPE_KEYS.ICON]}
              size="small"
            />
          </span>}
          {formatMessage(messages[contentTypes[CONTENT_TYPE_KEYS.LABEL].split(' ').join('_').toLowerCase()])}
        </div>
        <span className={classes.selectedSpan}>
          {selectedContentType.includes(contentTypes[CONTENT_TYPE_KEYS.TYPE]) && <Icon
            color="inherit"
            name="Right"
            size="small"
          />}
        </span>
      </MenuItem>
    </Fragment>
  );
};

FilterListComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  contentTypes: PropTypes.object.isRequired,
  intl: intlShape,
  onMenuClick: PropTypes.func.isRequired,
  selectedContentType: PropTypes.array.isRequired
};

FilterListComponent.defaultProps = {
  intl: {}
};

export default withStyles(styles)(injectIntl(FilterListComponent));
